import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { CONSTANTS } from "../../utils/Constant/Constant";

const ToastNotification = ({ type, message, heading }) => {
  useEffect(() => {
    if (type === CONSTANTS.TOAST_SUCCESS) {
      if (!toast.isActive("success-toast")) {
        toast.success(
          <div>
            <strong>{heading}</strong>
            <p>{message}</p>
          </div>,
          {
            position: "top-center",
            toastId: "success-toast",
            autoClose: CONSTANTS.TOAST_DURATION_LONG,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          }
        );
      }
    } else if (type === CONSTANTS.TOAST_ERROR) {
      if (!toast.isActive("error-toast")) {
        toast.error(
          <div>
            <strong>{heading}</strong>
            <p>{message}</p>
          </div>,
          {
            position: "top-center",
            toastId: "error-toast",
            autoClose: CONSTANTS.TOAST_DURATION_LONG,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          }
        );
      }
    } else if (type === CONSTANTS.TOAST_WARNING) {
      if (!toast.isActive("warning-toast")) {
        toast.warn(
          <div>
            <strong>{heading}</strong>
            <p>{message}</p>
          </div>,
          {
            position: "top-center",
            toastId: "warning-toast",
            autoClose: CONSTANTS.TOAST_DURATION_LONG,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          }
        );
      }
    }
  }, [type, heading, message]);

  return null;
};

export default ToastNotification;
